import { render, staticRenderFns } from "./BaseLogo.vue?vue&type=template&id=06637b56&"
import script from "./BaseLogo.vue?vue&type=script&lang=js&"
export * from "./BaseLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports